var klaviyo = window.klaviyo || [];

export default () => ({
  loaded: false,
  data: {
    items: []
  },
  beforeAjax() {
    Alpine.store("ajaxWorking", true);
  },
  afterAjax(add = false) {
    if (!document.body.classList.contains("template--cart")) {
      Alpine.store("cartOpen", true);
    }
    this.getCartData(add);
  },
  getCartData(add = false) {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((json) => {
        Alpine.store("ajaxWorking", false);
        this.loaded = true;
        this.data = {
          ...json,
          // If need to filter hidden items, do it here.
          quantity: json.items.reduce((a, b) => a + b.quantity, 0)
        };

        //Klaviyo tracking
        if (add) {
          klaviyo.push([
            "track",
            "Added to Cart",
            {
              total_price: this.data.total_price / 100,
              $value: this.data.total_price / 100,
              total_discount: this.data.total_discount,
              original_total_price: this.data.original_total_price / 100,
              items: this.data.items,
            },
          ]);
        }
      });
  },
  clear() {
    this.beforeAjax();
    fetch("/cart/clear.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then((response) => {
      this.cartError = !response.ok;
      this.afterAjax();
    });
  },
  addCartItem(variantId, quantity = 1, properties = {}, selling_plan = false) {
    this.beforeAjax();
    fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        properties: properties,
        ...(selling_plan ? { selling_plan: selling_plan } : {})
      }),
    }).then((response) => {
      this.cartError = !response.ok;
      this.afterAjax(true);
    });
  },
  updateCartItem(variantIdOrKey, quantity = 1) {
    const isAdding = this.data.items.some(
      (item) =>
        (item.variant_id == variantIdOrKey || item.key == variantIdOrKey) &&
        item.quantity < quantity
    );
    this.beforeAjax();
    fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ id: variantIdOrKey, quantity }),
    }).then((response) => {
      this.cartError = !response.ok;
      this.afterAjax(isAdding);
    });
  },
  removeCartItem(variantId) {
    this.updateCartItem(variantId, 0);
  },
});

//Can call the update via
// window.updateAlpineCart = () =>
//   document
//     .querySelector('body')
//     .dispatchEvent(new CustomEvent('cart-update'));
